var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 monthly_list"},[_c('p',[_vm._v("お支払いが正常に完了いたしました。 "),_c('br'),_vm._v("次回請求書より、本決済で使用されたクレジットカードで決済が行われます。")])])}]

export { render, staticRenderFns }